export const handleSubmit = ({ createAsset, history, currentCustomerId, isCommonAsset }) => values => {
  const updatedData = createAsset({
    variables: {
      assetInput: {
        ...values,
        customerId: undefined,
      },
      customerId: currentCustomerId,
    },
  });

  return updatedData.then(result => {
    const asset = result.data.createAsset ? result.data.createAsset : result.data.createCommonAsset;
    if (asset && asset.id) {
      history.replace(`/asset/details/${asset.id}${isCommonAsset ? "" : `/customer/${currentCustomerId}`}`);
    }
  });
};
